


export type SupportedLanguage = "en" | "es" | "ar" | "ca" | "zh-CN" | "zh-TW" | "cs" | "da" | "de" | "fr" | "fi" | "el" | "he" | "id" | "it" | "ja" | "ko" | "lt" | "nl" | "pl" | "pt" | "pt-BR" | "ro" | "ru" | "sl" | "th" | "tr" | "hu" | "sv" | "vi";

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ["en", "es", "ar", "ca", "zh-CN", "zh-TW", "cs", "da", "de", "fr", "fi", "el", "he", "id", "it", "ja", "ko", "lt", "nl", "pl", "pt", "pt-BR", "sl", "ro", "ru", "th", "tr", "hu", "sv", "vi"];


